import React from 'react';
import PropTypes from 'prop-types';
import { Block } from 'shared-components';

import { Container, DepartureSelectorGroup } from 'components';
import { DepartureGuestList } from 'containers';

const ReservationWrapper = ({ departures, ...props }) => (
  <Block {...props}>
    <div>
      <Container>
        <DepartureSelectorGroup options={departures} />
        {departures.map(d => <DepartureGuestList key={d} id={d} />)}
      </Container>
    </div>

  </Block>
);

ReservationWrapper.propTypes = {
  departures: PropTypes.array,
};
ReservationWrapper.defaultProps = {
  departures: [],
};

export default ReservationWrapper;



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationWrapper/index.js